import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';

export const MuiTextField: Components<Theme>['MuiTextField'] = {
  defaultProps: {
    fullWidth: true,
    slotProps: {
      inputLabel: { shrink: true },
    },
  },
  variants: [
    {
      props: { variant: 'outlined' },
      style: ({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',

        '& .MuiInputLabel-root': {
          position: 'static',
          transform: 'none',
          transformOrigin: 'unset',
          fontSize: theme.typography.pxToRem(14),
          fontWeight: 500,
          color: colors.black[700],
          marginBottom: theme.spacing(0.75),
          maxWidth: '100%',

          '&.Mui-focused': { color: colors.black[700] },
          '&.Mui-disabled': { color: colors.black[700] },
          '&.Mui-error': { color: colors.black[700] },

          '& .MuiFormLabel-asterisk': { color: colors.red[600] },

          ...theme.applyStyles('dark', {
            color: colors.black[100],
            '&.Mui-focused': { color: colors.black[100] },
            '&.Mui-disabled': { color: colors.black[100] },
            '&.Mui-error': { color: colors.black[100] },
          }),
        },

        '& .MuiOutlinedInput-notchedOutline': {
          top: 0,
          borderColor: theme.palette.divider,
          transition: 'border-color 0.2s, border-width 0.1s',

          '& legend': { display: 'none' },
        },

        '& .MuiInputBase-root': {
          borderRadius: theme.spacing(1),
          padding: theme.spacing(1, 1.5),

          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.divider,
          },

          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main,
            borderWidth: '2px',
          },

          '&.Mui-disabled': {
            cursor: 'not-allowed',

            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.divider,
            },
            '& svg': { color: colors.black[300] },
          },

          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: colors.red[300],
          },
          '&.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: colors.red[500],
            borderWidth: '2px',
          },
        },

        '& .MuiInputBase-input': {
          padding: 0,
          fontSize: theme.typography.pxToRem(16),
          lineHeight: theme.spacing(3),
          color: colors.black[950],
          ...theme.applyStyles('dark', {
            color: colors.black[25],
          }),

          '&::placeholder': {
            color: colors.gray[300],
            opacity: 1,
            ...theme.applyStyles('dark', {
              color: colors.black[300],
            }),
          },

          '&:disabled': {
            color: colors.black[300],
            WebkitTextFillColor: colors.black[300],
            cursor: 'not-allowed',
            ...theme.applyStyles('dark', {
              color: colors.black[600],
              WebkitTextFillColor: colors.black[600],
            }),
          },
        },
      }),
    },
  ],
  styleOverrides: {
    root: ({ theme }) => ({
      '& .MuiFormHelperText-root': {
        margin: theme.spacing(0.5, 0, 0, 0),
        fontSize: theme.typography.pxToRem(14),
        color: colors.black[600],
        // TODO: add dark mode color for helper text
        // TODO: add dark mode color for helper text error state

        '&.Mui-error': { color: colors.red[600] },
      },
    }),
  },
};
